import styles from "@styles/containers/oraculo/customer-drawer/data-tab.module.scss";

import { Hairline } from "@components";
import { If } from "@components/control-statements";
import {
  Climate,
  CustomerTag,
  DayPeriod,
  Temperature,
  WeekPeriod,
  YearPeriod,
} from "@core/oraculo/CustomerTag";

const buildTags = (tags) => {
  const tagsMap = {
    day: DayPeriod,
    week: WeekPeriod,
    year: YearPeriod,
    climate: Climate,
    temperature: Temperature,
  };

  const mountedTags = Object.entries(tags).map(([tagName, tagValue]) => {
    const tagEnum = tagsMap[tagName];
    const mountedTags = CustomerTag.fromEnum(tagEnum, tagValue);
    return mountedTags;
  });

  return mountedTags.flat(1);
};

const ConsumeTag = ({ name, icon }) => {
  return (
    <div className={styles.tag}>
      {icon && <i className={icon} />}
      {name}
    </div>
  );
};

export default function ({ customer }) {
  const { tags } = customer || {};

  const mountedTags = buildTags(tags || {});

  return (
    <div className={styles.consumptionPatterns}>
      <p className={styles.title}>Padrões de consumo</p>
      <Hairline solid className="mt-20 mb-20" />
      <div className={styles.tags}>
        {mountedTags.map((tag) => (
          <ConsumeTag name={tag.name} icon={tag.icon} />
        ))}
      </div>
      <If cond={mountedTags.length === 0}>
        <div className="d-flex flex-column align-center">
          <div className={styles.empty}>
            Nenhum padrão de consumo disponível
          </div>
        </div>
      </If>
    </div>
  );
}
